import { findControls, sliderThumbs } from "@plugins";

const benefits = document.querySelectorAll(".js-benefits");
const benefitsSliderOptions = {
    spaceBetween: 10,
    allowTouchMove: true,
};

if (benefits.length > 0) {
    for (const benefit of benefits) {
        const benefitsSliderContainer = benefit.querySelector(".js-benefits-slider");
        const benefitsSliderControls = findControls(benefit, ".js-benefits-controls");
        sliderThumbs(
            benefit,
            benefitsSliderContainer,
            benefitsSliderControls,
            benefitsSliderOptions,
        );
    }
}
